import { render, staticRenderFns } from "./medicion-frecuencia-editar.vue?vue&type=template&id=2a06634e&scoped=true&"
import script from "./medicion-frecuencia-editar.vue?vue&type=script&lang=js&"
export * from "./medicion-frecuencia-editar.vue?vue&type=script&lang=js&"
import style0 from "./medicion-frecuencia-editar.vue?vue&type=style&index=0&id=2a06634e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06634e",
  null
  
)

export default component.exports